import { words } from 'lodash';

export const checkStringWordsLessThan = (str, lessThanValue) => words(str).length < lessThanValue;
